import React from 'react';
import LinksListPage from 'modules/my-sales/submodules/links/list/page';

const LinksPage = () => {
  return <LinksListPage />;
};

export default LinksPage;
